/* projects/shared/src/lib/components/file-selector/file-selector.component.scss */
:host {
  display: inline-flex;
}
/*# sourceMappingURL=file-selector.component.css.map */
